export default __webpack_public_path__ + "static/media/awftm.8d7d9d21.svg";